(() => {
  const activeClass = 'toc-clickable__link--active';

  const setActive = (links, anchorId) => {
    links.forEach((link) => {
      link.classList.toggle(activeClass, link.dataset.anchorId === anchorId);
    });
  };

  const initSection = (section) => {
    if (!section || section.dataset.tocInitialized === 'true') {
      return;
    }

    section.dataset.tocInitialized = 'true';
    const offset = Number(section.dataset.scrollOffset) || 0;
    const links = Array.from(section.querySelectorAll('[data-anchor-id]'));
    const targets = links
      .map((link) => document.getElementById(link.dataset.anchorId))
      .filter(Boolean);

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const anchorId = link.dataset.anchorId;
        const target = document.getElementById(anchorId);

        if (!anchorId || !target) {
          return;
        }

        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });
        history.replaceState(null, '', `#${anchorId}`);
      });
    });

    if ('IntersectionObserver' in window && targets.length > 0) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

          if (visible[0]) {
            setActive(links, visible[0].target.id);
          }
        },
        {
          rootMargin: `-${offset}px 0px -60% 0px`,
          threshold: [0, 0.1, 0.5]
        }
      );

      targets.forEach((target) => observer.observe(target));
      return;
    }

    if (targets.length > 0) {
      const handleScroll = () => {
        let currentId = targets[0].id;

        targets.forEach((target) => {
          if (target.getBoundingClientRect().top - offset <= 10) {
            currentId = target.id;
          }
        });

        setActive(links, currentId);
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    }
  };

  document.querySelectorAll('.toc-clickable[data-section-id]').forEach(initSection);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.toc-clickable[data-section-id]');
    initSection(section);
  });
})();
